module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.f9a44e1c.svg";